import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Grid } from '@vio/atlas/helpers/Grid';
import { Price } from '@vio/atlas/Price';
import { SelectionCard } from '@vio/atlas/SelectionCard';
import { Text } from '@vio/atlas/Text';
import { getShowTotalPrices } from 'modules/sapiSearch/selectors';
import { getIsMultiRoomBundlesSearch } from 'modules/search/selectors';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { getNightlyPriceForAllRooms } from '@daedalus/core/src/price/business/price';
import { getCheckOutDate } from '@daedalus/core/src/searchParams/validateSearchParamDates';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
import { RoundingStrategy } from '@daedalus/core/src/utils/number';
import { RateBreakdown } from '@findhotel/sapi';
interface Props {
  date: string;
  currency: string;
  price: number;
  priceBreakdown: RateBreakdown;
  roundingStrategy: RoundingStrategy;
  isSelected: boolean;
  nights: number;
  rooms: number;
  dataId: string;
  isCheapest: boolean;
  onClick: () => void;
}
const _exp = /*#__PURE__*/() => Flex.Row;
const TileWrapper = /*#__PURE__*/styled(_exp())({
  name: "TileWrapper",
  class: "t1403ahh",
  propsAsIs: true
});
const TileContent = /*#__PURE__*/styled('div')({
  name: "TileContent",
  class: "thadaqm",
  propsAsIs: false
});
const PriceWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWrapper",
  class: "p1fyikg9",
  propsAsIs: false
});
const DateWrapper = /*#__PURE__*/styled('div')({
  name: "DateWrapper",
  class: "dktt6up",
  propsAsIs: false
});
export const AvailabilityTile = ({
  date,
  currency,
  price,
  priceBreakdown,
  roundingStrategy,
  isSelected,
  nights,
  dataId,
  isCheapest,
  rooms,
  onClick
}: Props) => {
  const {
    formatDate,
    formatMessage
  } = useIntl();
  const showTotalPrices = useSelector(getShowTotalPrices);
  const isMultiRoomBundlesSearch = useSelector(getIsMultiRoomBundlesSearch);
  const calculatedNightlyPrice = getNightlyPriceForAllRooms(price, isMultiRoomBundlesSearch, rooms);
  const calculatedPrice = showTotalPrices ? priceBreakdown.base + priceBreakdown.taxes + priceBreakdown.hotelFees : calculatedNightlyPrice;
  return <TileWrapper>
      <SelectionCard dataId={dataId} onChange={onClick} selected={isSelected} name="availability-tile" type="radio" withControlButton={false} size={'md'} labelText={isCheapest ? formatMessage({
      id: 'cheapest',
      defaultMessage: 'Cheapest'
    }) : undefined}>
        <TileContent>
          <DateWrapper data-id="AvailabilityTileDates">
            <Text variant="bodyS" colorPath="content.neutral.c950">
              {formatDate(dateStringToMiddayDate(date), {
              day: '2-digit',
              month: 'short'
            })}{' '}
              -{' '}
              {formatDate(getCheckOutDate(date, nights), {
              day: '2-digit',
              month: 'short'
            })}
            </Text>
          </DateWrapper>

          <PriceWrapper>
            <Grid container spacing="s200" alignItems="center">
              <Grid mobileSm="fit">
                <Text variant="bodyS" colorPath="content.neutral.c950">
                  <FormattedMessageWrapper id="from" defaultMessage="From" />
                </Text>
              </Grid>
              <Grid mobileSm="fit">
                <Text variant="titleM" colorPath="content.neutral.c999">
                  <Price noStyle currency={currency} value={calculatedPrice} roundingStrategy={roundingStrategy} dataId="AvailabilityTilePrice" />
                </Text>
              </Grid>
            </Grid>
          </PriceWrapper>
        </TileContent>
      </SelectionCard>
    </TileWrapper>;
};

require("./AvailabilityTile.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AvailabilityTile.tsx");